<div class="container">
  <div class="row justify-content-center align-items-center min-vh-100">
    <div class="col-12 col-sm-8 col-md-6 col-lg-4">
      <mat-card class="text-center">
        <mat-card-header>
          <mat-card-title>
            <div class="text-center w-100">
              <mat-icon class="page-icon text-warning">dns</mat-icon>
              <h2>Error de Conexión</h2>
              <p class="text-muted fst-italic">Servicio no disponible</p>
            </div>
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="alert alert-warning">
            Lo sentimos, hubo un problema al invocar el <strong>servicio de autorización.</strong>
            Las credenciales son válidas pero no se pudo obtener el
            <strong>contexto del usuario</strong>.
          </div>
        </mat-card-content>

        <mat-card-actions class="px-3 pb-3">
          <div class="row g-2">
            <div class="col-6">
              <button mat-flat-button color="primary" class="w-100" (click)="goBack()">
                <mat-icon>refresh</mat-icon>
                Reintentar
              </button>
            </div>
            <div class="col-6">
              <button mat-flat-button color="warn" class="w-100" (click)="signOut()">
                <mat-icon>meeting_room</mat-icon>
                Salir
              </button>
            </div>
          </div>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
